import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="flex flex-col gap-2">
            <Link to="/" className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
              OOPBuy <span className="text-accent-500">Spreadsheet</span>
            </Link>
            <p className="text-sm text-foreground-600 max-w-md">
              {t('footer.disclaimer')}
            </p>
          </div>

          {/* Guides */}
          <div className="flex flex-col gap-2">
            <h4 className="text-sm font-semibold text-foreground-900 mb-1">Einkaufsführer</h4>
            <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
              Anfänger Guide
            </Link>
            <Link to="/versand-guide" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.versand')}
            </Link>
            <Link to="/qc-guide" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.qc')}
            </Link>
            <Link to="/oopbuy-vs-pandabuy" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.compare')}
            </Link>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-2">
            <h4 className="text-sm font-semibold text-foreground-900 mb-1">Links</h4>
            <Link to="/" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.home')}
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            {t('footer.copyright')}
          </p>
          <p className="text-xs text-foreground-400">
            powered by Readdy
          </p>
        </div>
      </div>
    </footer>
  );
}